import styled from 'styled-components'

export const Container = styled.div`
	justify-content: center;
	display: grid;
	grid-gap: 0 34px;
	min-height: 190px;
	grid-template-rows: 20px 56px 42px auto;
	grid-template-columns: 150px 280px auto;
	grid-template-areas:
		'foto x x'
		'foto nome nome'
		'foto identificador status'
		'foto periodo_curso data';

	.spinner-container {
		grid-column: 1/5;
		grid-row: 1/5;
		align-self: center;
	}

	a {
		height: 155px;

		img {
			border-radius: 50%;
			align-self: center;
			height: 160px;
		}
	}

	h1 {
		font-size: 28px;
		font-weight: 300;
		text-transform: uppercase;
	}

	.identificador {
		display: flex;
		align-items: flex-start;

		.situacao {
			display: flex; 
			align-items: center;
			margin-left: 20px;

			svg {
				margin-right: 4px;
			}
		}
	}

	.nome_reduzido {
		display: none;
	}

	@media(max-width: 900px) {
		margin-bottom: 14px;
		grid-template-rows: 20px 44px 30px 30px 30px 30px;
		grid-template-columns: 150px auto;
		grid-template-areas:
			'foto x'
			'foto nome'
			'foto identificador'
			'foto status'
			'foto periodo_curso'
			'foto data';
	}

	@media(max-width: 800px) {
		align-items: center;
		display: flex;
		flex-direction: column;
		gap: 1rem;

		h1 {
			font-size: 20px;
			font-weight: 500;
		}

		.identificador > b {
			font-weight: unset;
		}

		.nome_completo {
			display: none;
		}

		.nome_reduzido {
			display: block;
		}

		.especialidade {
			text-align: center;
			padding: 0 20px;
		}
	}

	@media(max-width: 440px) {
		margin-bottom: 0;
	}
`

export const Avatar = styled.div`
	grid-area: foto;
	border-radius: 50%;
	width: 150px;
	height: 150px;
	background-image: url(${props => props.image});
	background-position: center;
	background-size: cover;

	@media(max-width: 880px) {
		width: 150px;
		height: 150px;
		padding-top: unset;
	}
`
